import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { key: 1 }
const _hoisted_2 = { class: "py-1" }
const _hoisted_3 = { class: "py-1" }
const _hoisted_4 = { key: 2 }

import { computed, PropType } from 'vue';
import { useStore } from 'vuex';
import Copy from '@/components/micro/CopyComponent.vue';
import Duration from '@/components/micro/DurationComponent.vue';
import RawRecords from '@/components/micro/RawRecords.vue';
import Alert from '@/components/micro/AlertComponent.vue';
import CnameChainBadge from '@/components/micro/CnameChainBadge.vue';
import DnsRecordsLink from '@/components/micro/DnsRecordsLink.vue';
import { NS, QueryResult, RecordInfo } from '@/model/Api';

type NsRecordWithInfo = {
  record: NS;
} & RecordInfo


export default /*@__PURE__*/_defineComponent({
  __name: 'NsRecords',
  props: {
  records: {
    type: Object as PropType<QueryResult>,
    required: true,
  },
  domain: {
    type: String,
    required: true,
  },
},
  setup(__props) {

const props = __props;

const store = useStore();
const showRawOutput = computed(() => store.state.showRawOutput);

const processedRecords = computed(() => {
  const processed: NsRecordWithInfo[] = props.records.response.answer.filter((item): item is NsRecordWithInfo => item.record.recordType === 'NS');
  return processed;
});
const parentDomain = computed(() => props.domain.substring(props.domain.indexOf('.') + 1));

return (_ctx: any,_cache: any) => {
  return (showRawOutput.value)
    ? (_openBlock(), _createBlock(RawRecords, {
        key: 0,
        records: __props.records
      }, null, 8, ["records"]))
    : (processedRecords.value.length !== 0)
      ? (_openBlock(), _createElementBlock("table", _hoisted_1, [
          _cache[0] || (_cache[0] = _createElementVNode("colgroup", null, [
            _createElementVNode("col", { class: "w-3/4" }),
            _createElementVNode("col", { class: "w-1/4" })
          ], -1)),
          _cache[1] || (_cache[1] = _createElementVNode("thead", null, [
            _createElementVNode("tr", { class: "border-b-2 border-gray-200 text-left" }, [
              _createElementVNode("th", {
                scope: "col",
                class: "py-1.5 font-medium"
              }, "Name server"),
              _createElementVNode("th", {
                scope: "col",
                class: "py-1.5 font-medium"
              }, "Revalidate in")
            ])
          ], -1)),
          _createElementVNode("tbody", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(processedRecords.value, (record, index) => {
              return (_openBlock(), _createElementBlock("tr", {
                key: index,
                class: "group"
              }, [
                _createElementVNode("td", _hoisted_2, [
                  _createElementVNode("span", null, [
                    _createVNode(DnsRecordsLink, {
                      domain: record.record.target,
                      class: "text-blue-600 hover:text-blue-800 hover:underline"
                    }, null, 8, ["domain"])
                  ]),
                  _createVNode(CnameChainBadge, {
                    chain: record.cnameChain
                  }, null, 8, ["chain"]),
                  _createVNode(Copy, {
                    content: record.record.target,
                    class: "[visibility:hidden] group-hover:visible"
                  }, null, 8, ["content"])
                ]),
                _createElementVNode("td", _hoisted_3, [
                  _createVNode(Duration, {
                    seconds: record.record.ttl
                  }, null, 8, ["seconds"])
                ])
              ]))
            }), 128))
          ])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _cache[4] || (_cache[4] = _createElementVNode("span", null, "No NS records found.", -1)),
          _createVNode(Alert, { type: "info" }, {
            default: _withCtx(() => [
              _cache[2] || (_cache[2] = _createTextVNode("The name servers for this domain are inherited from one of its ancestor domains. Try its parent domain: ", -1)),
              _createVNode(DnsRecordsLink, {
                domain: parentDomain.value,
                class: "font-semibold hover:underline"
              }, null, 8, ["domain"]),
              _cache[3] || (_cache[3] = _createTextVNode(". ", -1))
            ]),
            _: 1
          })
        ]))
}
}

})